import CLUBS_JSON from '../config/tulum-clubs-config.json';
export default CLUBS_JSON;
